module.exports = __webpack_public_path__ + "static/media/independent.fd8616ec.png";